var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtractor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none",
    fill: "#3F64FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Align_group",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 12.9214V7.07143H14.7857V12.9214C13.8857 13.1786 13.1786 13.8857 12.9214 14.7857H7.07143V16.0714H12.9214C13.1786 17.1643 14.2071 18 15.4286 18C16.8429 18 18 16.8429 18 15.4286C18 14.2071 17.1643 13.2429 16.0714 12.9214ZM15.4286 16.7143C14.7214 16.7143 14.1429 16.1357 14.1429 15.4286C14.1429 14.7214 14.7214 14.1429 15.4286 14.1429C16.1357 14.1429 16.7143 14.7214 16.7143 15.4286C16.7143 16.1357 16.1357 16.7143 15.4286 16.7143ZM5.14286 18H0V12.8571H5.14286V18ZM1.28571 16.7143H3.85714V14.1429H1.28571V16.7143ZM5.07857 3.21429H10.9286V1.92857H5.07857C4.75714 0.835714 3.79286 0 2.57143 0C1.15714 0 0 1.15714 0 2.57143C0 3.79286 0.835714 4.75714 1.92857 5.07857V10.9286H3.21429V5.07857C4.11429 4.82143 4.82143 4.11429 5.07857 3.21429ZM2.57143 3.85714C1.86429 3.85714 1.28571 3.27857 1.28571 2.57143C1.28571 1.86429 1.86429 1.28571 2.57143 1.28571C3.27857 1.28571 3.85714 1.86429 3.85714 2.57143C3.85714 3.27857 3.27857 3.85714 2.57143 3.85714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 0V1.28571H15.8142L5.78564 11.3143L6.68564 12.2143L16.7142 2.18571V5.14286H17.9999V0H12.8571Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractor);
export default __webpack_public_path__ + "static/media/extractor.3c0921e9e2284b0406f34c3baaa62783.svg";
export { ForwardRef as ReactComponent };